import React, { Component } from 'react';
import moment from 'moment';
import {
    Form,
    Row,
    Col,
    DatePicker,
    TimePicker,
    Typography,
} from 'antd';
import styled from 'styled-components';
import FormStepTitle from '../FormStepTitle';
import BookingCalendar from '../../booking/BookingCalendar';
import BookingTime from '../../booking/BookingTime';
import FormError from '../FormError';
import logger from '../../../services/logger';
import { db, COLLECTION_BOOKING_DATES_REF } from '../../../firebase';
import {
    getMonthDateRange,
    createBookingDateTime,
    getDisabledDays,
    getDisabledHours,
} from '../../../utils';


const { Text } = Typography;

const StyledCol = styled(Col)`
    @media (max-width: ${props => props.theme.breakpoint.sm}px) {
        margin-top: ${props => props.theme.unit * 5}px;
    }
`;

class FormStepDateTime extends Component {
    state = {
        activeDatesForMonth: [],
        unavailableDays: [],
        unavailableTimeSlots: [],
        loading: true,
        activeMonth: moment(),
        hasError: false,
    };
    
    componentDidMount() {
        this.fetchBookingsForMonth();
    }

    componentDidUpdate(_, prevState) {
        if (prevState.activeMonth !== this.state.activeMonth) {
            this.fetchBookingsForMonth();
        }
    }

    fetchBookingsForMonth = async () => {
        const { activeMonth } = this.state;
        const { start, end } = getMonthDateRange(activeMonth);

        this.setState({ loading: true });

        try {
            let activeDatesForMonth = [];
            const snapshot = await db.collection(COLLECTION_BOOKING_DATES_REF)
                .where('date_time', '>', start)
                .where('date_time', '<', end)
                .get();

            if (!snapshot.empty) {
                snapshot.forEach(doc => activeDatesForMonth.push(doc.data()));
            }

            this.setState({
                activeDatesForMonth,
                unavailableDays: getDisabledDays(activeDatesForMonth),
                loading: false,
            });
        } catch(error) {
            this.handleError(error);
        }
    }

    handleSubmit = time => {
        const { getFieldValue } = this.props.form;
        const date = getFieldValue('date');

        this.props.submitStep({
            bookingDateTime: createBookingDateTime(date, time)
        });
    }

    handleError = error => {
        logger.error('Error receive bookings for Date & Time step: ' + error);

        this.setState({ hasError: true });
    }

    onSelectedDayChange = e => {
        const { activeDatesForMonth } = this.state;

        this.setState({ unavailableTimeSlots: getDisabledHours(e, activeDatesForMonth) });

        this.props.form.setFieldsValue({ date: e });

        this.setState({ errorMessage: null });
    }

    setActiveMonth = date => {
        this.setState({ activeMonth: date });
    }

    render() {
        const {
            unavailableDays,
            unavailableTimeSlots,
            loading,
            hasError,
        } = this.state;
        const { form, formItemLayout, isFormStep } = this.props;
        const { getFieldDecorator, getFieldValue } = form;
        const selectedDate = getFieldValue('date');

        if (hasError) {
            return <FormError />;
        }

        return (
            <Row gutter={40}>
                <Col span={isFormStep ? 12 : 24} md={isFormStep ? 12 : null} xs={24}>
                    <BookingCalendar
                        onChange={this.onSelectedDayChange}
                        setActiveMonth={this.setActiveMonth}
                    />
                </Col>
                <StyledCol span={isFormStep ? 12 : 24} md={isFormStep ? 12 : null} xs={24}>
                    {
                        isFormStep
                        ? <FormStepTitle label="Select a date & time for your booking" />
                        : <div style={{ margin: 40 }} />
                    }
                    <Text>
                        <Text strong>Selected Date: </Text> { selectedDate ? selectedDate.format('LL') : moment().format('LL') }
                    </Text>
                    <Form {...formItemLayout} style={{ marginTop: isFormStep ? 40 : 16 }}>
                        <Form.Item>
                            {
                                getFieldDecorator('bookingDateTime')(
                                    <BookingTime
                                        unavailableDays={unavailableDays}
                                        unavailableTimeSlots={unavailableTimeSlots}
                                        handleSubmit={this.handleSubmit}
                                        selectedDate={selectedDate}
                                        loading={loading}
                                    />
                                )
                            }
                        </Form.Item>
                        <div style={{ display: 'none' }}>
                            <Form.Item>
                                {
                                    getFieldDecorator('time', { initialValue: moment() })(
                                        <TimePicker />
                                    )
                                }
                            </Form.Item>
                            <Form.Item>
                                {
                                    getFieldDecorator('date', { initialValue: moment() })(
                                        <DatePicker />
                                    )
                                }
                            </Form.Item>
                        </div>
                    </Form>
                </StyledCol>
            </Row>
        );
    }
}

export default Form.create({ name: 'date_time' })(FormStepDateTime);
